"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = void 0;
var Channel;
(function (Channel) {
    Channel["apiDefsUpdated"] = "api-defs-updated";
    Channel["logsUpdated"] = "logs-updated";
    Channel["ping"] = "ping";
    Channel["recentLogs"] = "recent-logs";
})(Channel || (Channel = {}));
exports.Channel = Channel;
//# sourceMappingURL=channel.enum.js.map